import React from 'react';
import { Button, Tooltip } from 'antd';
import LocalizedDate from '../../Localization/LocalizedDate';
import api from '../../../Api';
import { connectToRequests } from '../../Requests/containers/RequestsDataStore';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';

export function EnableRequestLabel({ submittedDate }) {
	return (
		<React.Fragment>
			Enable cancelled request
			<br />
			<span style={{ fontSize: 'smaller' }}>
				(made on <LocalizedDate dateString={submittedDate} />)
			</span>
		</React.Fragment>
	);
}

export class EnableRequest extends React.Component {
	render() {
		if (this.props.isMobile()) {
			return this.renderButton();
		}
		return (
			<Tooltip title={this.getTooltip()} placement="left">
				{this.renderButton()}
			</Tooltip>
		);
	}

	renderButton = () => {
		return (
			<Button shape="circle" onClick={this.enableRequest}>
				<div className="relative">
					<div className="icon-hand-paper-o request-hand" />
					<div
						className="icon-undo enable-request"
						style={{
							fontSize: '9px',
							position: 'absolute',
							bottom: '5px',
							right: '10px',
							color: '#fc601f',
						}}
					/>
				</div>
			</Button>
		);
	};

	getTooltip() {
		const { submittedDate } = this.props;
		return <EnableRequestLabel submittedDate={submittedDate} />;
	}

	enableRequest = () => {
		const { sku } = this.props;

		api.post(`/api/me/galleys/${sku}/enable`).then(res => {
			this.props.requestsDataStore.refresh();
		});
	};
}

export default connectToRequests(withIsMobile(EnableRequest));
